import { render, staticRenderFns } from "./setCourse.vue?vue&type=template&id=dd1c97ca&scoped=true&"
import script from "./setCourse.vue?vue&type=script&lang=js&"
export * from "./setCourse.vue?vue&type=script&lang=js&"
import style0 from "./setCourse.vue?vue&type=style&index=0&id=dd1c97ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd1c97ca",
  null
  
)

export default component.exports